import { c as _c } from "react/compiler-runtime";
export function ManifestFile() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <link rel="manifest" href="/manifest.json" crossOrigin="use-credentials" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}